import classNames from 'classnames';
import { forwardRef } from 'react';
import Image from '@/shared/components/shared/Image';
import Responsive from '@/shared/components/shared/Responsive';
import { useTypograf } from '@/shared/hooks/use-typograf';
import { ImageShape } from '@/shared/lib/types';

type Props = React.HTMLAttributes<HTMLElement> & {
    properties: {
        image: ImageShape;
        text: string | null;
    };
};

const ConstructorImage = forwardRef<HTMLDivElement, Props>(({ properties: { image, text }, ...props }, ref) => {
    const tpDescription = useTypograf(text ?? '');

    return (
        <div {...props} ref={ref} className={classNames('constructor-block constructor-image', props.className)}>
            <Responsive className="constructor-image-el">
                {image?.src && (
                    <Image
                        src={image.src}
                        width={image.width}
                        height={image.height}
                        alt={image.alt || ''}
                        title={image.title}
                        sizes="100vw"
                    />
                )}
            </Responsive>
            {tpDescription && <div className="constructor-image-text text-xs">{tpDescription}</div>}
        </div>
    );
});

ConstructorImage.displayName = 'ConstructorImage';

export default ConstructorImage;
